// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  projectId: __t.u64().primaryKey().name("project_id"),
  issuer: __t.identity(),
  title: __t.string(),
  kind: __t.string(),
  targetKey: __t.string().name("target_key"),
  goal: __t.u32(),
  rewardPerSov: __t.i64().name("reward_per_sov"),
  budgetSov: __t.i64().name("budget_sov"),
  paidSov: __t.i64().name("paid_sov"),
  progress: __t.u32(),
  state: __t.string(),
  createdAt: __t.timestamp().name("created_at"),
  expiresAt: __t.timestamp().name("expires_at"),
});
